import Vue from 'vue'
import Router from 'vue-router'
import index from '@/pages/index'
import detail from '@/pages/detail'
import inside from '@/pages/inside'
Vue.use(Router)
export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
      meta: {
        pageName: 'index',
      }
    },
    {
      path: '/index',
      name: 'index',
      component: index,
      meta: {
        pageName: 'index',
      }
    },
    {
      path: '/detail',
      name: 'detail',
      component: detail,
      meta: {
        pageName: 'detail',
      }
    },
    {
      path: '/inside',
      name: 'inside',
      component: inside,
      meta: {
        pageName: 'inside',
      }
    }
    
  ],
  scrollBehavior(to,from,savedPosition){
    if(savedPosition){
      return savedPosition;
    }else{
      return {x:0,y:0}
    }
  },

})



// WEBPACK FOOTER //
// ./src/router/index.js